import { types } from 'mobx-state-tree';
import { getVideoProcessingFromLocalStorage } from 'utils/psaHelpers';

export const PsaStore = types
  .model('PsaStore', {
    currentPsa: types.maybeNull(types.string),
    videoProcessing: types.maybeNull(types.boolean),
  })
  .actions((self) => ({
    afterCreate() {
      self.videoProcessing = getVideoProcessingFromLocalStorage() || false;
      self.currentPsa = localStorage.getItem('psa_id') || '';
    },

    setVideoProcessing(videoProcessing) {
      console.log('setVideoProcessing');
      self.videoProcessing = videoProcessing;
      localStorage.setItem('videoProcessing', JSON.stringify(videoProcessing));
    },
  }));
